import {
  estaOculta,
  motivoParaNaoOcultar,
  secaoPadrao,
  secoesOrdenadas,
} from '@/conversas/secoesInbox';

/**
 * Bloco "Seções da lista": ordem, visibilidade e qual abre por padrão.
 *
 * Sem arrastar-e-soltar. Setas dão conta de quatro itens, funcionam no teclado
 * e não exigem biblioteca — o arrastar só ganharia de verdade numa lista longa,
 * que esta não é.
 *
 * Lista TODAS as seções, ocultas inclusive: é aqui que uma seção escondida
 * volta, e ela precisa estar visível em algum lugar para isso.
 */
export default function BlocoSecoesInbox({ preferencias, mover, alternarVisibilidade, tornarPadrao }) {
  const secoes = secoesOrdenadas(preferencias);
  const padrao = secaoPadrao(preferencias);

  return (
    <section className="config-bloco">
      <h3 className="config-titulo">Seções da lista</h3>
      <p className="campo-ajuda">
        Vale só para você. A estrela marca a seção que já abre; o olho esconde uma
        seção da lista, mesmo quando ela tem conversas.
      </p>

      <ul className="secoes-config">
        {secoes.map((secao, i) => {
          const oculta = estaOculta(preferencias, secao.id);
          const impedimento = motivoParaNaoOcultar(preferencias, secao.id);
          const ehPadrao = padrao === secao.id;

          return (
            <li key={secao.id} className={oculta ? 'secao-linha oculta' : 'secao-linha'}>
              <span className="secao-setas">
                <button
                  type="button"
                  className="btn-icone"
                  onClick={() => mover(secao.id, -1)}
                  disabled={i === 0}
                  aria-label={`Mover ${secao.label} para cima`}
                  title="Mover para cima"
                >
                  ↑
                </button>
                <button
                  type="button"
                  className="btn-icone"
                  onClick={() => mover(secao.id, +1)}
                  disabled={i === secoes.length - 1}
                  aria-label={`Mover ${secao.label} para baixo`}
                  title="Mover para baixo"
                >
                  ↓
                </button>
              </span>

              <span className="secao-nome">
                {secao.label}
                {oculta && <span className="secao-marca">oculta</span>}
              </span>

              {/* Seção oculta não pode ser a padrão: a lista abriria numa seção
                  que ela mesma não desenha. */}
              <button
                type="button"
                className={ehPadrao ? 'btn-icone estrela ativa' : 'btn-icone estrela'}
                onClick={() => tornarPadrao(secao.id)}
                disabled={oculta || ehPadrao}
                aria-pressed={ehPadrao}
                aria-label={`Abrir ${secao.label} por padrão`}
                title={
                  ehPadrao
                    ? 'Já é a seção que abre por padrão'
                    : oculta
                      ? 'Mostre a seção antes de torná-la padrão'
                      : 'Abrir esta seção por padrão'
                }
              >
                {ehPadrao ? '★' : '☆'}
              </button>

              <button
                type="button"
                className="btn-icone"
                onClick={() => alternarVisibilidade(secao.id)}
                disabled={Boolean(impedimento)}
                aria-label={oculta ? `Mostrar ${secao.label}` : `Ocultar ${secao.label}`}
                // O motivo vem do módulo puro, não de um `if` aqui: a tela e a
                // regra não podem discordar sobre por que o botão travou.
                title={impedimento ?? (oculta ? 'Mostrar na lista' : 'Ocultar da lista')}
              >
                {oculta ? '🚫' : '👁'}
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
